import { Alert, Stack, Tooltip, Typography } from "@mui/material";
import { UndeliverableEmailRecordType } from "pages/SharedRecords.types";
import { useTranslate } from "react-admin";
type UndeliverableEmailsListingPropsType = {
  undeliverableEmails: UndeliverableEmailRecordType[];
  heading: string;
};
function UndeliverableEmailsListing(props: UndeliverableEmailsListingPropsType) {
  const { undeliverableEmails, heading } = props;

  if (undeliverableEmails.length === 0) return null;

  return (
    <Stack>
      <Typography variant="subtitle2">{heading}</Typography>

      <Stack>
        {undeliverableEmails.map((e) => (
          <Typography variant="body2" key={`${e.id}-${e.name}`}>
            {e.name}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
}

type UndeliverableEmailAlertPropsType = {
  undeliverableEmails: UndeliverableEmailRecordType[];
};
export default function UndeliverableEmailAlert(props: UndeliverableEmailAlertPropsType) {
  const { undeliverableEmails } = props;
  const translate = useTranslate();

  if (undeliverableEmails.length === 0) return null;

  const withoutEmailAddress = undeliverableEmails.filter((fr) => fr.failure_reason === "no_email_address");
  const withoutConsent = undeliverableEmails.filter((fr) => fr.failure_reason === "no_consent_given");

  const tooltipTitle = (
    <Stack gap={2}>
      <UndeliverableEmailsListing
        undeliverableEmails={withoutEmailAddress}
        heading={translate("resources.emails.hints.noEmailAddress")}
      />
      <UndeliverableEmailsListing
        undeliverableEmails={withoutConsent}
        heading={translate("resources.emails.hints.noListConsentGiven")}
      />
    </Stack>
  );

  return (
    <Alert severity="info">
      <Tooltip title={tooltipTitle} arrow>
        <Typography>{translate("resources.emails.hints.undeliverableEmails", undeliverableEmails.length)}</Typography>
      </Tooltip>
    </Alert>
  );
}
